import React from 'react';
import { PAGE_CONFIG } from '../../constants/pages';
import FlexColumn from '../shared/FlexColumn';
import Header from '../layout/Header';

// This component renders all the pages in the PAGE_CONFIG constant
// Additionally, It renders the layout of the page
// To edit the layout, edit the Header and Menu components
// To edit the pages, edit the PAGE_CONFIG constant / pages folder files

const PagesRenderer = ({ token }) => {
  const [Page, setPage] = React.useState(PAGE_CONFIG[0]);

  const handleChangePage = (page) => {
    const new_page = PAGE_CONFIG.find((p) => p.name === page);
    if (Page.name !== new_page.name) setPage(new_page);
  };

  return (
    <FlexColumn>
      <Header changePage={handleChangePage} currentPage={Page.name} />
      <Page.renderComponent token={token} />
    </FlexColumn>
  );
};

export default PagesRenderer;
